import { Dialog } from '@hai/ui-react';
import React, { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { StreamViewModel } from './stream-models';

interface Props {
  itemsToDelete: StreamViewModel[];
  onApply?: (items: StreamViewModel[]) => void;
  onCancel?: VoidFunction;
}

export const StreamDeleteConfirmModal: React.FunctionComponent<Props> = ({ itemsToDelete, onApply, onCancel }) => {
  const { t } = useTranslation();

  const handleDelete = (): void => {
    onApply(itemsToDelete);
  };
  
  const handleOnKeyUp = (e: React.KeyboardEvent<HTMLElement>): void => {    
    if (e.key === 'Enter') {
      if ((e.target as HTMLElement)?.id?.toString().includes('-submit')) {
        // from submit button, dont submit twice
        return;
      }
      handleDelete();
    }
  };  
  
    useLayoutEffect((): void => {
      const el = document.getElementById('stream-delete-confirm-modal-submit');
      if (el) {
        el.focus();
      }
    }, []);

  return (
    <Dialog
      headline={t('stream.deleteModal.title', { count: itemsToDelete.length })}
      bodyText={t('general.cannotUndo')}
      onClose={onCancel}
      onKeyUp={handleOnKeyUp}
      show={true}
      buttons={[
        { label: t('general.cancel') },
        { label: t('general.deleteBtn'), variant: 'danger', onClick: handleDelete, id: 'stream-delete-confirm-modal-submit'  },
      ]}
    />
  );
};
